export const getTerritoryManageMembershipPageUrl = (territorySlug: string): string =>
  `/t/${territorySlug}/manage-membership`;
